import React, { useCallback } from 'react';
import styled                 from 'styled-components';
import Radio                  from '@material-ui/core/Radio';

const RadioButtonWrapper = styled.div`
  display       : flex;
  align-items   : end;
  width         : 100%;
  font-size     : 15px;
  margin-top    : 15px;
  margin-bottom : 15px;

  p {
    line-height: 25px;

    span {
      color       : black;
      font-size   : 18px;
      font-weight : 400;
    }
  }
`;

const StyledRadioButton = styled(Radio)`
  && {
    padding : 0 8px 0px 0px;
    color   : ${({ theme }: any): string => theme.backgroundColor.darkLightBlue} !important;
  }
`;

export const RadioButton = ({
  field,
  form,
  id,
  option,
}: any): JSX.Element => {
  const onValueChange = useCallback(
    ({ target }: any): void => {
      form.setFieldValue(field.name, target.id);
    },
    [field, form],
  );

  return (
    <RadioButtonWrapper>
      <StyledRadioButton
        {...field}
        id       = {id}
        color    = "primary"
        checked  = {id === field.value}
        onChange = {onValueChange}
      />
      <p>{option && <><span>{option}</span></>}</p>
    </RadioButtonWrapper>
  );
};
